function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from "react";
import * as Api from "../ajax/SessionApi";
import IntlMessage from '../commons/Intl';
import { Action, AuthoringMessage, Label, Placeholder } from '../commons/IntlMessages';
import UploadMessageMaterialsInstanceModel from "../models/session/UploadMessageMaterialsInstanceModel";
import UploadMessageMaterialsItemInstanceModel from "../models/session/UploadMessageMaterialsItemInstanceModel";
import { MessageItemTypes } from "../enum/MessageItemTypes";
var defaultLanguage = 'ja';
var intl = new IntlMessage(defaultLanguage);
var language = window.navigator.language.substring(0, 2) === 'ja' ? 'ja' : 'en';
intl.setLanguage(language); // オーサリングメッセージ管理モーダル

/**
 * モード
 */

export var Mode;

(function (Mode) {
  /**
   * なし
   */
  Mode[Mode["None"] = 0] = "None";
  /**
   * 追加
   */

  Mode[Mode["Add"] = 1] = "Add";
})(Mode || (Mode = {}));
/**
 * メッセージ管理モーダルコンポーネント
 */


var SessionAuthoringMessageModalComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(SessionAuthoringMessageModalComponent, _React$Component);

  var _super = _createSuper(SessionAuthoringMessageModalComponent);

  /**
   * フィールド変数の初期化を行います。
   *
   * @param props プロップス
   */
  function SessionAuthoringMessageModalComponent(props) {
    var _this;

    _classCallCheck(this, SessionAuthoringMessageModalComponent);

    _this = _super.call(this, props);

    switch (props.mode) {
      case Mode.Add:
        _this.state = {
          Modal: null,
          SessionId: _this.props.sessionId,
          SearchText: "",
          MessageList: [],
          SelectedMessage: null,
          IsNew: false,
          ErrorMessages: []
        };
        break;

      default:
        throw Error();
    }

    _this.getUploadMessageMaterialsList(_this.props.sessionId, _this.props.messageId);

    return _this;
  }
  /**
   * 会議素材（メッセージ）一覧取得
   *
   * @param sessionId 会議ID
   * @param messageId メッセージID
   */


  _createClass(SessionAuthoringMessageModalComponent, [{
    key: "getUploadMessageMaterialsList",
    value: function getUploadMessageMaterialsList(sessionId, messageId) {
      var _this2 = this;

      Api.GetUploadMessageMaterialsList(this.props.sessionId, function (data) {
        _this2.setState({
          MessageList: data.UploadMessageMaterialsList
        }, function () {
          if (messageId != null && messageId != "") {
            _this2.getUploadMessageMaterials(_this2.props.sessionId, Number(messageId));
          }
        });
      });
    }
    /**
     * 会議素材（メッセージ）取得
     *
     * @param sessionId 会議ID
     * @param messageId メッセージID
     */

  }, {
    key: "getUploadMessageMaterials",
    value: function getUploadMessageMaterials(sessionId, messageId) {
      var _this3 = this;

      Api.GetUploadMessageMaterials(sessionId, messageId, function (data) {
        _this3.setState({
          SelectedMessage: data,
          IsNew: false
        });
      });
    }
    /**
     * 「メッセージを追加」ボタン押下時の処理を行います。
     */

  }, {
    key: "addMessage",
    value: function addMessage() {
      var newId = 0;

      if (this.state.MessageList.length > 0) {
        for (var i = 0; i < this.state.MessageList.length; i++) {
          if (newId < this.state.MessageList[i].MessageId) newId = this.state.MessageList[i].MessageId;
        }

        newId++;
      }

      var message = new UploadMessageMaterialsInstanceModel();
      message.SessionId = this.props.sessionId;
      message.MessageId = newId;
      var itemId = 0;

      if (message.MessageItems != null && message.MessageItems.length > 0) {
        itemId = message.MessageItems.length;
      }

      var messageItem = new UploadMessageMaterialsItemInstanceModel();
      messageItem.SessionId = message.SessionId;
      messageItem.MessageId = message.MessageId;
      messageItem.ItemId = itemId;
      messageItem.ItemType = MessageItemTypes.Normal;
      message.MessageItems.push(messageItem);
      message.Interactable = message.MessageItems.length > 0 ? 1 : 0;
      this.setState({
        SelectedMessage: message,
        IsNew: true
      });
    }
    /**
     * 「メッセージを更新」ボタン押下時の処理を行います。
     */

  }, {
    key: "updateMessage",
    value: function updateMessage() {
      var _this4 = this;

      if (this.state.Modal == null) {
        throw Error();
      }

      if (this.state.SelectedMessage == null) return;
      var form = $("#MainForm");
      $.validator.unobtrusive.parse(form);
      form.validate();

      if (form.valid()) {
        this.state.ErrorMessages.length = 0;

        if (this.state.ErrorMessages.length != 0) {
          this.setState({
            ErrorMessages: this.state.ErrorMessages
          });
          return;
        }

        if (this.state.SelectedMessage.IsQuiz) {
          for (var i = 0; i < this.state.SelectedMessage.MessageItems.length; i++) {
            if (this.state.SelectedMessage.MessageItems[i].ItemType == MessageItemTypes.Normal) {
              this.state.SelectedMessage.MessageItems[i].ItemType = MessageItemTypes.Incorrect;
            }
          }
        } else {
          for (var i = 0; i < this.state.SelectedMessage.MessageItems.length; i++) {
            if (this.state.SelectedMessage.MessageItems[i].ItemType != MessageItemTypes.Normal) {
              this.state.SelectedMessage.MessageItems[i].ItemType = MessageItemTypes.Normal;
            }
          }
        }

        var message = JSON.stringify(this.state.SelectedMessage);

        if (this.state.IsNew) {
          Api.AddUploadMessageMaterials(message, function () {
            _this4.setState({
              SelectedMessage: null,
              IsNew: false
            }, function () {
              _this4.getUploadMessageMaterialsList(_this4.props.sessionId, null);
            });
          });
        } else {
          Api.ModifyUploadMessageMaterials(message, function () {
            _this4.setState({
              SelectedMessage: null,
              IsNew: false
            }, function () {
              _this4.getUploadMessageMaterialsList(_this4.props.sessionId, null);
            });
          });
        }
      }
    }
    /**
     * 「メッセージを削除」ボタン押下時の処理を行います。
     */

  }, {
    key: "delMessage",
    value: function delMessage() {
      var _this5 = this;

      if (this.state.SelectedMessage == null) return;
      var message = this.state.SelectedMessage;
      Api.DeleteUploadMessageMaterials(message.SessionId, message.MessageId, function () {
        _this5.setState({
          SelectedMessage: null,
          IsNew: false
        }, function () {
          _this5.getUploadMessageMaterialsList(_this5.props.sessionId, null);
        });
      });
    }
    /**
     * メッセージの選択状態を切り替えます
     *
     * @param m モデル
     */

  }, {
    key: "changeSelectedMessage",
    value: function changeSelectedMessage(m) {
      var _this6 = this;

      //前回と同じ場合は、未選択
      if (this.state.SelectedMessage != null && this.state.SelectedMessage == m) {
        this.setState({
          SelectedMessage: null,
          IsNew: false
        });
        return;
      }

      this.setState({
        SelectedMessage: m,
        IsNew: false
      }, function () {
        if (_this6.state.SelectedMessage == null) return;
        var message = _this6.state.SelectedMessage;

        _this6.getUploadMessageMaterials(message.SessionId, message.MessageId);
      });
    }
    /**
     * 「メッセージアイテムを追加」ボタン押下時の処理を行います。
     */

  }, {
    key: "addMessageItem",
    value: function addMessageItem() {
      if (this.state.SelectedMessage == null) return;
      var message = this.state.SelectedMessage;
      var itemId = 0;

      if (message.MessageItems != null && message.MessageItems.length > 0) {
        itemId = message.MessageItems.length;
      }

      var messageItem = new UploadMessageMaterialsItemInstanceModel();
      messageItem.SessionId = message.SessionId;
      messageItem.MessageId = message.MessageId;
      messageItem.ItemId = itemId;
      message.MessageItems.push(messageItem);
      message.Interactable = message.MessageItems.length > 0 ? 1 : 0;
      this.setState({
        SelectedMessage: message
      });
    }
    /**
     * タイトルを更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateTitle",
    value: function updateTitle(e) {
      if (this.state.SelectedMessage == null) return;
      var message = this.state.SelectedMessage;
      message.Title = e.target.value.substring(0, e.target.maxLength);
      this.setState({
        SelectedMessage: message
      });
    }
    /**
     * 内容を更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateContents",
    value: function updateContents(e) {
      if (this.state.SelectedMessage == null) return;
      var message = this.state.SelectedMessage;
      message.Contents = e.target.value.substring(0, e.target.maxLength);
      this.setState({
        SelectedMessage: message
      });
    }
    /**
     * 解説文を更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateExplanation",
    value: function updateExplanation(e) {
      if (this.state.SelectedMessage == null) return;
      var message = this.state.SelectedMessage;
      message.Explanation = e.target.value.substring(0, e.target.maxLength);
      this.setState({
        SelectedMessage: message
      });
    }
    /**
     * アイテム名を更新します。
     */

  }, {
    key: "updateMessageItem",
    value: function updateMessageItem(e, index) {
      if (this.state.SelectedMessage == null) return;
      var message = this.state.SelectedMessage;
      if (message.MessageItems.length <= index) return;
      message.MessageItems[index].ItemName = e.target.value.substring(0, e.target.maxLength);
      this.setState({
        SelectedMessage: message
      });
    }
    /**
     * 「メッセージを削除」ボタン押下時の処理を行います。
     */

  }, {
    key: "delMessageItem",
    value: function delMessageItem(index) {
      if (this.state.SelectedMessage == null) return;
      var message = this.state.SelectedMessage;
      if (message.MessageItems.length <= index) return;
      message.MessageItems.splice(index, 1);

      for (var i = 0; i < message.MessageItems.length; i++) {
        message.MessageItems[i].ItemId = i;
      }

      message.Interactable = message.MessageItems.length > 0 ? 1 : 0;
      this.setState({
        SelectedMessage: message
      });
    }
    /**
     * 「クイズ形式にする」チェックボックス押下時の処理を行います。
     */

  }, {
    key: "checkMakeQuiz",
    value: function checkMakeQuiz(e) {
      if (this.state.SelectedMessage == null) return;
      var message = this.state.SelectedMessage;

      if (e.target.checked) {
        message.IsQuiz = 1;

        if (message.MessageItems.length == 0) {
          var itemId = 0;

          if (message.MessageItems != null && message.MessageItems.length > 0) {
            itemId = message.MessageItems.length;
          }

          var messageItem = new UploadMessageMaterialsItemInstanceModel();
          messageItem.SessionId = message.SessionId;
          messageItem.MessageId = message.MessageId;
          messageItem.ItemId = itemId;
          messageItem.ItemType = MessageItemTypes.Correct;
          message.MessageItems.push(messageItem);
        } else if (message.MessageItems.filter(function (m) {
          return m.ItemType == MessageItemTypes.Correct;
        }).length == 0) {
          message.MessageItems[0].ItemType = MessageItemTypes.Correct;
        }
      } else {
        message.IsQuiz = 0;

        if (message.MessageItems.length == 0) {
          var itemId = 0;

          if (message.MessageItems != null && message.MessageItems.length > 0) {
            itemId = message.MessageItems.length;
          }

          var messageItem = new UploadMessageMaterialsItemInstanceModel();
          messageItem.SessionId = message.SessionId;
          messageItem.MessageId = message.MessageId;
          messageItem.ItemId = itemId;
          messageItem.ItemType = MessageItemTypes.Normal;
          message.MessageItems.push(messageItem);
        }
      }

      message.Interactable = message.MessageItems.length > 0 ? 1 : 0;
      this.setState({
        SelectedMessage: message
      });
    }
    /**
     * 「正解するまで繰り返す」チェックボックス押下時の処理を行います。
     */

  }, {
    key: "checkRetryUntilCorrect",
    value: function checkRetryUntilCorrect(e) {
      if (this.state.SelectedMessage == null) return;
      var message = this.state.SelectedMessage;

      if (e.target.checked) {
        message.CanIncorrectNext = 1;
      } else {
        message.CanIncorrectNext = 0;
      }

      this.setState({
        SelectedMessage: message
      });
    }
    /**
     * 「正解」チェックボックス押下時の処理を行います。
     */

  }, {
    key: "checkCorrect",
    value: function checkCorrect(e, index) {
      if (this.state.SelectedMessage == null) return;
      var message = this.state.SelectedMessage;
      if (message.MessageItems.length <= index) return;

      if (e.target.checked) {
        message.MessageItems[index].ItemType = MessageItemTypes.Correct;
      } else {
        message.MessageItems[index].ItemType = MessageItemTypes.Incorrect;
      }

      this.setState({
        SelectedMessage: message
      });
    }
    /**
     * 検証処理
     */

  }, {
    key: "isValidate",
    value: function isValidate(index) {
      if (this.state.SelectedMessage == null) {
        return true;
      }

      if (this.state.SelectedMessage.MessageItems.length <= index) return true;

      if (!this.state.SelectedMessage.IsQuiz) {
        if (this.state.SelectedMessage.MessageItems.length == 1) {
          return false;
        }

        return true;
      }

      if (this.state.SelectedMessage.MessageItems[index].ItemType != MessageItemTypes.Correct) {
        return true;
      }

      if (this.state.SelectedMessage.MessageItems.filter(function (m) {
        return m.ItemType == MessageItemTypes.Correct;
      }).length == 1) {
        return false;
      }

      return true;
    }
    /**
     * 「戻る」ボタン押下時の処理を行います。
     */

  }, {
    key: "onBack",
    value: function onBack() {
      if (this.state.Modal == null) {
        throw Error();
      }

      this.props.onBack();
      this.state.Modal.modal('hide');
    }
    /**
     * 検索テキストを更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateSearchText",
    value: function updateSearchText(e) {
      this.setState({
        SearchText: e.target.value.substring(0, e.target.maxLength)
      });
    }
    /**
     * ComponentがDOMツリーに追加された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this7 = this;

      var modal = $('#SessionAuthoringMessageDialogModal');
      this.setState({
        Modal: modal
      });
      modal.modal({
        backdrop: 'static',
        keyboard: false
      }); // ポップアップが完全に非表示になった時のイベント。

      modal.on("hidden.bs.modal", function () {
        _this7.props.onHidden();
      });
      $("form").removeData("validator").removeData("unobtrusiveValidation").off("submit.validate click.validate focusin.validate focusout.validate keyup.validate invalid-form.validate");
      $.validator.unobtrusive.parse("form");
    }
    /**
     * レンダラー
     */

  }, {
    key: "render",
    value: function render() {
      var _this8 = this;

      return /*#__PURE__*/React.createElement("div", {
        className: "modal fade",
        id: "SessionAuthoringMessageDialogModal",
        role: "dialog"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-dialog modal-lg",
        role: "document"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-content"
      }, this.state.ErrorMessages.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "validation-summary-errors alert alert-danger"
      }, /*#__PURE__*/React.createElement("ul", null, this.state.ErrorMessages.map(function (x, i) {
        return /*#__PURE__*/React.createElement("li", {
          key: i
        }, x);
      }))), /*#__PURE__*/React.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-title"
      }, /*#__PURE__*/React.createElement("img", {
        className: "modalIcon",
        width: "48",
        height: "38",
        src: "/assets/img/Icon_Message_Gray.svg"
      }), /*#__PURE__*/React.createElement("h3", null, intl.format(AuthoringMessage.Title))), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "modal-close",
        "data-dismiss": "modal",
        "aria-label": "Close",
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7"))), /*#__PURE__*/React.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12 mx-auto"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-4"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12 messageMain__headerBtnArea"
      }, /*#__PURE__*/React.createElement("button", {
        className: "messageMain__addBtn",
        onClick: this.addMessage.bind(this),
        type: "button"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_Add.svg"
      }), /*#__PURE__*/React.createElement("p", null, intl.format(Action.AddMessage))), this.state.SelectedMessage != null && /*#__PURE__*/React.createElement("button", {
        className: "messageMain__delBtn",
        onClick: this.delMessage.bind(this),
        type: "button"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/delete_icon.svg"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "col-12 form-inline select-wrap-top"
      }, /*#__PURE__*/React.createElement("div", {
        className: "input-group col-12"
      }, /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "form-control",
        maxLength: 40,
        onChange: function onChange(e) {
          return _this8.updateSearchText(e);
        },
        value: this.state.SearchText,
        tabIndex: 101,
        placeholder: intl.format(Placeholder.SearchWord)
      }))), /*#__PURE__*/React.createElement("div", {
        className: "select-wrap-bottom"
      }, this.state.MessageList.length == 0 && /*#__PURE__*/React.createElement("div", {
        className: "col-12 list-group list-group-flush list-group-message"
      }, intl.format(AuthoringMessage.NoMessage)), this.state.MessageList.length > 0 && /*#__PURE__*/React.createElement("ul", {
        className: "col-12 list-group list-group-flush"
      }, this.state.MessageList.filter(function (x) {
        return x.Title.indexOf(_this8.state.SearchText) >= 0;
      }).map(function (x, _i) {
        return /*#__PURE__*/React.createElement("li", {
          onClick: _this8.changeSelectedMessage.bind(_this8, x),
          className: "list-group-item " + (_this8.state.SelectedMessage != null && _this8.state.SelectedMessage.MessageId == x.MessageId ? "selected" : "")
        }, /*#__PURE__*/React.createElement("p", null, x.Title), /*#__PURE__*/React.createElement("p", null, x.Contents));
      })))), /*#__PURE__*/React.createElement("div", {
        className: "col-7 offset-left"
      }, this.state.SelectedMessage != null && !this.state.SelectedMessage.IsQuiz && [/*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-2 col-form-label",
        htmlFor: "Title"
      }, intl.format(Label.Title)), /*#__PURE__*/React.createElement("div", {
        className: "col-10"
      }, /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "form-control",
        name: "Title",
        id: "Title",
        maxLength: 40,
        onChange: function onChange(e) {
          return _this8.updateTitle(e);
        },
        value: this.state.SelectedMessage.Title,
        tabIndex: 102,
        placeholder: intl.format(Placeholder.Letters, {
          value: "40"
        })
      }))), /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-2 col-form-label",
        htmlFor: "Contents"
      }, intl.format(Label.Contents)), /*#__PURE__*/React.createElement("div", {
        className: "col-10"
      }, /*#__PURE__*/React.createElement("textarea", {
        className: "form-control",
        name: "Contents",
        id: "Contents",
        rows: 3,
        maxLength: 200,
        onChange: function onChange(e) {
          return _this8.updateContents(e);
        },
        value: this.state.SelectedMessage.Contents,
        tabIndex: 103,
        placeholder: intl.format(Placeholder.Letters, {
          value: "200"
        })
      }))), /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-2 col-form-label"
      }), /*#__PURE__*/React.createElement("div", {
        className: "col-5"
      }, /*#__PURE__*/React.createElement("div", {
        className: "checkbox icheck-asbestos"
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        id: "MakeQuiz",
        name: "MakeQuiz",
        onChange: this.checkMakeQuiz.bind(this),
        checked: this.state.SelectedMessage.IsQuiz == 1,
        tabIndex: 104
      }), /*#__PURE__*/React.createElement("label", {
        htmlFor: "MakeQuiz"
      }, intl.format(AuthoringMessage.MakeQuiz))))), /*#__PURE__*/React.createElement("div", {
        className: "col-10 col-lg-12"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "authoring"
      }, /*#__PURE__*/React.createElement("div", {
        className: "authoringMain"
      }, /*#__PURE__*/React.createElement("ul", {
        className: "authoringConts"
      }, this.state.SelectedMessage.MessageItems != null && this.state.SelectedMessage.MessageItems.length > 0 && this.state.SelectedMessage.MessageItems.map(function (x, i) {
        return /*#__PURE__*/React.createElement("li", {
          className: "authoringCont"
        }, /*#__PURE__*/React.createElement("ul", {
          className: "authoringCont__list"
        }, /*#__PURE__*/React.createElement("li", {
          className: "authoringCont__item"
        }, /*#__PURE__*/React.createElement("input", {
          type: "text",
          className: "form-control",
          name: "Button",
          id: "Button",
          maxLength: 40,
          onChange: function onChange(e) {
            return _this8.updateMessageItem(e, i);
          },
          value: x.ItemName,
          tabIndex: 201,
          placeholder: intl.format(Placeholder.Letters, {
            value: "40"
          })
        })), /*#__PURE__*/React.createElement("li", {
          className: "authoringCont__item authoringCont__item--btn"
        }, _this8.isValidate(i) && /*#__PURE__*/React.createElement("button", {
          className: "authoringCont__btn authoringCont__btn--del",
          onClick: _this8.delMessageItem.bind(_this8, i),
          type: "button"
        }, /*#__PURE__*/React.createElement("img", {
          src: "/assets/img/delete_icon.svg"
        })), !_this8.isValidate(i) && /*#__PURE__*/React.createElement("button", {
          className: "authoringCont__btn authoringCont__btn--del",
          disabled: true,
          type: "button"
        }, /*#__PURE__*/React.createElement("img", {
          src: "/assets/img/delete_icon.svg"
        })))));
      })), this.state.SelectedMessage != null && this.state.SelectedMessage.MessageItems != null && this.state.SelectedMessage.MessageItems.length < 6 && /*#__PURE__*/React.createElement("button", {
        className: "authoringMain__addBtn",
        onClick: this.addMessageItem.bind(this),
        type: "button"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_Add.svg"
      }), /*#__PURE__*/React.createElement("p", null, intl.format(Action.AddButton)))))))], this.state.SelectedMessage != null && this.state.SelectedMessage.IsQuiz && [/*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-2 col-form-label",
        htmlFor: "Title"
      }, intl.format(Label.Title)), /*#__PURE__*/React.createElement("div", {
        className: "col-10"
      }, /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "form-control",
        name: "Title",
        id: "Title",
        maxLength: 40,
        onChange: function onChange(e) {
          return _this8.updateTitle(e);
        },
        value: this.state.SelectedMessage.Title,
        tabIndex: 102,
        placeholder: intl.format(Placeholder.Letters, {
          value: "40"
        })
      }))), /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-2 col-form-label",
        htmlFor: "Contents"
      }, intl.format(Label.Contents)), /*#__PURE__*/React.createElement("div", {
        className: "col-10"
      }, /*#__PURE__*/React.createElement("textarea", {
        className: "form-control",
        name: "Contents",
        id: "Contents",
        rows: 3,
        maxLength: 200,
        onChange: function onChange(e) {
          return _this8.updateContents(e);
        },
        value: this.state.SelectedMessage.Contents,
        tabIndex: 103,
        placeholder: intl.format(Placeholder.Letters, {
          value: "200"
        })
      }))), /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-2 col-form-label"
      }), /*#__PURE__*/React.createElement("div", {
        className: "col-5"
      }, /*#__PURE__*/React.createElement("div", {
        className: "checkbox icheck-asbestos"
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        id: "MakeQuiz",
        name: "MakeQuiz",
        onChange: this.checkMakeQuiz.bind(this),
        checked: this.state.SelectedMessage.IsQuiz == 1,
        tabIndex: 104
      }), /*#__PURE__*/React.createElement("label", {
        htmlFor: "MakeQuiz"
      }, intl.format(AuthoringMessage.MakeQuiz)))), /*#__PURE__*/React.createElement("div", {
        className: "col-5"
      }, /*#__PURE__*/React.createElement("div", {
        className: "checkbox icheck-asbestos"
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        id: "RetryUntilCorrect",
        name: "RetryUntilCorrect",
        onChange: this.checkRetryUntilCorrect.bind(this),
        checked: this.state.SelectedMessage.CanIncorrectNext == 1,
        tabIndex: 105
      }), /*#__PURE__*/React.createElement("label", {
        htmlFor: "RetryUntilCorrect"
      }, intl.format(AuthoringMessage.RetryUntilCorrect))))), /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-2 col-form-label",
        htmlFor: "Explanation"
      }, intl.format(Label.Explanation)), /*#__PURE__*/React.createElement("div", {
        className: "col-10"
      }, /*#__PURE__*/React.createElement("textarea", {
        className: "form-control",
        name: "Explanation",
        id: "Explanation",
        rows: 3,
        maxLength: 200,
        onChange: function onChange(e) {
          return _this8.updateExplanation(e);
        },
        value: this.state.SelectedMessage.Explanation,
        tabIndex: 106,
        placeholder: intl.format(Placeholder.OptionLetters, {
          value: "200"
        })
      }))), /*#__PURE__*/React.createElement("div", {
        className: "col-10 col-lg-12"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "authoring"
      }, /*#__PURE__*/React.createElement("div", {
        className: "authoringMain"
      }, /*#__PURE__*/React.createElement("ul", {
        className: "authoringConts"
      }, this.state.SelectedMessage.MessageItems != null && this.state.SelectedMessage.MessageItems.length > 0 && this.state.SelectedMessage.MessageItems.map(function (x, i) {
        return /*#__PURE__*/React.createElement("li", {
          className: "authoringCont"
        }, /*#__PURE__*/React.createElement("ul", {
          className: "authoringCont__list"
        }, /*#__PURE__*/React.createElement("li", {
          className: "authoringCont__item authoringCont__item--80"
        }, /*#__PURE__*/React.createElement("input", {
          type: "text",
          className: "form-control",
          name: "Button",
          id: "Button",
          maxLength: 40,
          onChange: function onChange(e) {
            return _this8.updateMessageItem(e, i);
          },
          value: x.ItemName,
          tabIndex: 201,
          placeholder: intl.format(Placeholder.Letters, {
            value: "40"
          })
        })), /*#__PURE__*/React.createElement("li", {
          className: "authoringCont__item authoringCont__item--btn"
        }, _this8.isValidate(i) && /*#__PURE__*/React.createElement("button", {
          className: "authoringCont__btn authoringCont__btn--del",
          onClick: _this8.delMessageItem.bind(_this8, i),
          type: "button"
        }, /*#__PURE__*/React.createElement("img", {
          src: "/assets/img/delete_icon.svg"
        })), !_this8.isValidate(i) && /*#__PURE__*/React.createElement("button", {
          className: "authoringCont__btn authoringCont__btn--del",
          disabled: true,
          type: "button"
        }, /*#__PURE__*/React.createElement("img", {
          src: "/assets/img/delete_icon.svg"
        }))), /*#__PURE__*/React.createElement("li", {
          className: "authoringCont__item authoringCont__item--check"
        }, /*#__PURE__*/React.createElement("div", {
          className: "checkbox icheck-asbestos authoringCont__checkbox"
        }, /*#__PURE__*/React.createElement("label", {
          htmlFor: "Correct"
        }, intl.format(Label.Correct)), _this8.isValidate(i) && /*#__PURE__*/React.createElement("input", {
          type: "checkbox",
          id: "Correct",
          name: "Correct",
          onChange: function onChange(e) {
            return _this8.checkCorrect(e, i);
          },
          checked: x.ItemType == MessageItemTypes.Correct,
          tabIndex: 202
        }), !_this8.isValidate(i) && /*#__PURE__*/React.createElement("input", {
          type: "checkbox",
          id: "Correct",
          name: "Correct",
          disabled: true,
          checked: x.ItemType == MessageItemTypes.Correct,
          tabIndex: 202
        })))));
      })), this.state.SelectedMessage != null && this.state.SelectedMessage.MessageItems != null && this.state.SelectedMessage.MessageItems.length < 6 && /*#__PURE__*/React.createElement("button", {
        className: "authoringMain__addBtn",
        onClick: this.addMessageItem.bind(this),
        type: "button"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_Add.svg"
      }), /*#__PURE__*/React.createElement("p", null, intl.format(Action.AddButton)))))))])))), /*#__PURE__*/React.createElement("div", {
        className: "modal-footer justify-content-center"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-11 mx-auto"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-4 textAlignCenter"
      }, /*#__PURE__*/React.createElement("button", {
        className: "btn btn-default",
        type: "button",
        onClick: this.onBack.bind(this),
        tabIndex: -1
      }, intl.format(Action.Back))), /*#__PURE__*/React.createElement("div", {
        className: "col-7 offset-left textAlignCenter"
      }, this.state.SelectedMessage != null && /*#__PURE__*/React.createElement("button", {
        className: "btn btn-primary",
        type: "button",
        onClick: this.updateMessage.bind(this),
        tabIndex: -1
      }, intl.format(Action.Entry)))))))));
    }
  }]);

  return SessionAuthoringMessageModalComponent;
}(React.Component);

export { SessionAuthoringMessageModalComponent as default };